'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/7/27.
                                   */

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasyTabBar = (_dec = (0, _reactRedux.connect)('', { routerPush: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GoeasyTabBar, _Component);

  function GoeasyTabBar() {
    (0, _classCallCheck3.default)(this, GoeasyTabBar);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasyTabBar).call(this));
  }

  (0, _createClass3.default)(GoeasyTabBar, [{
    key: 'onChangeUrl',
    value: function onChangeUrl(url) {
      var routerPush = this.props.routerPush;

      if (routerPush) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        routerPush(url);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./GoeasyTabBar.scss');
      var _props = this.props;
      var data = _props.data;
      var activePath = _props.activePath;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          { className: styles.header },
          data instanceof Array ? data.map(function (item, index) {
            var currentClassName = '';
            if (item.strict && item.url === activePath) {
              currentClassName = styles.active;
            } else if (!item.strict && item.url && item.url !== '' && activePath.indexOf(item.url) > -1) {
              currentClassName = styles.active;
            }
            return _react2.default.createElement(
              'li',
              { className: currentClassName, key: index },
              _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this2.onChangeUrl(item.url);
                  },
                  to: item.url },
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement('img', { src: item.img,
                    alt: '' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  item.text
                )
              )
            );
          }) : ''
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.line })
      );
    }
  }]);
  return GoeasyTabBar;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.array,
  activePath: _react.PropTypes.string,
  routerPush: _react.PropTypes.func
}, _temp)) || _class);
exports.default = GoeasyTabBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyTabBar/GoeasyTabBar.js
 ** module id = 1348
 ** module chunks = 0
 **/